export class ApiResponseError extends Error {
  readonly responseStatus?: number;
  readonly response?: Response;

  constructor(responseStatus?: number, response?: Response) {
    super('An unexpected error occurred.');
    this.responseStatus = responseStatus;
    this.response = response;
  }
}
